
export const configuracionNormalize = (source) => {
    return {
        idConfiguracion: source.idConfiguracion ?? source.IdConfiguracion,
        nombre: source.nombre ?? source.Nombre ?? '',
        descripcion: source.descripcion ?? source.Descripcion ?? '',
        valor: source.valor ?? source.Valor ?? '',
        activo: source.activo ?? source.Activo ?? false
    }
}

